import { Box } from '@chakra-ui/react';
import { FingerNote } from '../../Finger/FingerNote';
import { Status } from './types';

type Props = {
  status: Status;
  reason?: string;
  description?: string;
  children?: React.ReactNode;
  deletedByTTL?: boolean;
};

const RenderDocInfo = ({ status, reason, description, children, deletedByTTL }: Props) => {
  if (deletedByTTL) {
    return (
      <Box fontWeight="medium" mb={1}>
        Deleted as per the data deletion schedule
      </Box>
    );
  }

  if (children || reason || description || status === Status.UploadedError) {
    return (
      <>
        {children}

        {reason && <FingerNote title="Reason for document rejection:" description={reason} />}

        {description && <FingerNote title="Custom document request:" description={description} />}
      </>
    );
  }

  return null;
};

export default RenderDocInfo;
